import { apiErrorMessages, facebookErrorMessages } from './Error.messages';

export const ERROR_CODE_MESSAGES = Object.freeze({
  4032: facebookErrorMessages.didNotSignupViaFacebook,
  4033: facebookErrorMessages.contactSupport,
  4034: facebookErrorMessages.didNotSignupViaFacebook,
  40331: facebookErrorMessages.missingEmail,
  4045: apiErrorMessages.incorrectPassword,
  4313: apiErrorMessages.billingError,
  4314: apiErrorMessages.billingError,
  4315: apiErrorMessages.billingError,
  4608: apiErrorMessages.suspect,
});
